import { gql } from '@apollo/client';

/**
 * 仓库是否为手动推送模式（分批次-尾程）。
 * DSP 线路页据此展示强提示；后端查询失败时返回 false，不阻断页面。
 */
export const IS_MANUAL_PUSH_WAREHOUSE = gql`
    query IsManualPushWarehouse($warehouseId: Long!) {
        manual: isManualPushWarehouse(warehouseId: $warehouseId)
    }
`;

export interface IsManualPushWarehouseResponse {
    manual: boolean;
}

export interface IsManualPushWarehouseVariables {
    warehouseId: number;
}
